import * as tslib_1 from "tslib";
import React from 'react';
import MenuItem from './MenuItem';
import MenuItemGroup from './MenuItemGroup';
import MenuCloser from './MenuCloser';
import matchComponent from '../utils/matchComponent';
import chainCallbacks from '../utils/chainCallbacks';
import { KEY } from '../types';
var Menu = /** @class */ (function (_super) {
    tslib_1.__extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isMenuItem = matchComponent(MenuItem);
        _this.isMenuItemGroup = matchComponent(MenuItemGroup);
        _this.closerRef = null;
        _this.setCloserRef = function (node) {
            _this.closerRef = node;
        };
        _this.handleKeyDown = function (event) {
            switch (event.keyCode) {
                case KEY.ENTER:
                    var _a = _this.getItemsAndActiveIndex(), items = _a.items, activeIndex = _a.activeIndex;
                    if (items.length === 0) {
                        return;
                    }
                    items[activeIndex].click();
                    break;
                case KEY.DOWN:
                    _this.focusNext();
                    event.preventDefault();
                    break;
                case KEY.UP:
                    _this.focusPrevious();
                    event.preventDefault();
                    break;
                case KEY.ESCAPE:
                case KEY.TAB:
                    if (_this.props.onClose !== undefined) {
                        _this.props.onClose(event);
                    }
                    break;
                default:
            }
        };
        return _this;
    }
    Menu.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, onSelect = _a.onSelect, componentClass = _a.componentClass, componentProps = _a.componentProps, componentType = _a.componentType, className = _a.className, selectedValue = _a.selectedValue, props = tslib_1.__rest(_a, ["children", "onSelect", "componentClass", "componentProps", "componentType", "className", "selectedValue"]);
        // This is necessary to ensure the compiler that the componentClass will not be empty even though it's optional
        var Component = componentClass || Menu.defaultProps.componentClass;
        return (React.createElement(MenuCloser, { innerRef: this.setCloserRef, onClose: this.props.onClose },
            React.createElement(Component, tslib_1.__assign({ className: className, role: "menu" }, componentProps), React.Children.map(children, function (child) {
                if (!React.isValidElement(child)) {
                    return child;
                }
                if (_this.isMenuItem(child)) {
                    return React.cloneElement(child, tslib_1.__assign({}, props, { selected: child.props.selected ||
                            (selectedValue !== undefined &&
                                child.props.value === selectedValue), onKeyDown: chainCallbacks(child.props.onKeyDown, _this.handleKeyDown), onSelect: chainCallbacks(child.props.onSelect, onSelect) }));
                }
                if (_this.isMenuItemGroup(child)) {
                    return React.cloneElement(child, tslib_1.__assign({}, props, { selectedValue: selectedValue, onKeyDown: chainCallbacks(child.props.onKeyDown, _this.handleKeyDown), onSelect: chainCallbacks(child.props.onSelect, onSelect) }));
                }
                return child;
            }))));
    };
    Menu.prototype.getItemsAndActiveIndex = function () {
        var items = this.getFocusableMenuItems();
        var activeIndex = document.activeElement
            ? items.indexOf(document.activeElement)
            : -1;
        return { items: items, activeIndex: activeIndex };
    };
    Menu.prototype.getFocusableMenuItems = function () {
        var node = this.closerRef;
        if (!node) {
            return [];
        }
        return Array.from(node.querySelectorAll('[tabIndex="-1"]:not([disabled])'));
    };
    Menu.prototype.focusNext = function () {
        var _a = this.getItemsAndActiveIndex(), items = _a.items, activeIndex = _a.activeIndex;
        if (items.length === 0) {
            return;
        }
        var nextIndex = activeIndex >= items.length - 1 ? 0 : activeIndex + 1;
        items[nextIndex].focus();
    };
    Menu.prototype.focusPrevious = function () {
        var _a = this.getItemsAndActiveIndex(), items = _a.items, activeIndex = _a.activeIndex;
        if (items.length === 0) {
            return;
        }
        var prevIndex = activeIndex <= 0 ? items.length - 1 : activeIndex - 1;
        items[prevIndex].focus();
    };
    Menu.defaultProps = {
        componentType: Menu,
        componentClass: 'div',
    };
    return Menu;
}(React.Component));
export default Menu;
//# sourceMappingURL=Menu.js.map